import { FileUploadSelectEvent } from "primereact/fileupload";
import { useRef } from "react";
import { setSidebar, setToast } from "../../../app/appSlice";
import { useAppDispatch, useAppSelector } from "../../../hooks/hooks";
import { setTopologyImported } from "../TreatmentSlice";
import { ImportTopologyForm } from "./ImportTopologyForm";
import { IMetadatas, RuntimeMode } from '../../../app/apiSlice';
import { LabelsSelectorsProvider, SelectedLabels } from '@kosmos/shared';

export interface ITopologyImported {
  name: string;
  description: string;
  graph: string;
  parallelism: number;
  data: string;
  environnement: string;
  runtimeMode: string;
  memoryRequest?: string;
  memoryLimit?: string;
  cpuRequest?: string;
  cpuLimit?: string;
  runtimeVersion?: string;
  listeZip?: string;
  forcedflowname?: string;
  modeBatch?: string;
  retentionTimeNats?: string;
  messageStore?: string;
  globalConfigAdditions?: string;
  treatmentVersion?: string;
  metadatas?: IMetadatas;
}

//Hook who handle import of topology
export const useImportTopology = () => {
  const sideBar = useAppSelector((state) => state.app.dialog);
  const dispatch = useAppDispatch();
  const fileUploadRef = useRef(null)

  //read selected file imported
  const onSelectFile = (e: FileUploadSelectEvent) => {
    const files = e.files[0];
    const reader = new FileReader();
    if (files) {
      reader.readAsText(files);
    }
    reader.onload = (e) => {
      try {
              // @ts-ignore
      const fileContent = JSON.parse(e.currentTarget.result);
      handleImport(fileContent,files.name);

      } catch  {
        importError()
      }
    };
  };

  //construct new topology with selected file informations
  const handleImport = (fileContent: any,fileName:string) => {
    if (
      fileContent.name !== null && fileContent.graph !== null && fileContent.environnement !== null && fileContent.data !== null &&
      fileContent.parallelism !== null && Object.values(RuntimeMode).find(mode => mode === fileContent.runtimeMode)
    ) {
      const topologyImported = fileContent as ITopologyImported;
      dispatch(setTopologyImported({
        fileName:fileName,
        importedTopology:topologyImported
      }))
      OpenSidebar();
    } else {
      importError();
    }
  };

  //Open the component that import topologies
  const OpenSidebar = () => {
      if(!sideBar) {
        dispatch(
          setSidebar({
            title: "Importer",
            content: (
              <LabelsSelectorsProvider serviceUrl="/api/labels?vstoreobject=topologies">
                <ImportTopologyForm
                  onClose={() => {
                    dispatch(setSidebar());
                  }}
                />
              </LabelsSelectorsProvider>
            ),
          })
        );
        clearImport()
      }
  };


  // Error displayed when the import is incorrect
  const importError = () => {
    dispatch(
      setToast({
        content:
          "Le ficiher que vous essayez d'importer n'est pas au bon format.",
        life: 3000,
        severity: "error",
        title: "Erreur !",
      })
    );
    clearImport()
  };

  //clear file import 
  const clearImport = () => {
    if (fileUploadRef.current) {
      // @ts-ignore
      fileUploadRef.current.clear();
    }
  };

  return {
    onSelectFile,
    fileUploadRef,
    clearImport,
  };
};
